module.exports = __webpack_public_path__ + "img/zunjing.3c83f001.png";